var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('v-card-text',{staticClass:"text-xs-center",attrs:{"id":"loader"}},[_c('v-progress-circular',{staticClass:"my-3",attrs:{"indeterminate":"","color":"grey lighten-1"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }